module.exports = __webpack_public_path__ + "img/diagram_bwg1.85c03a4d.png";